import gql from "graphql-tag";

// Fetches the current user's authentication, permissions, and feature access details.
// Used to control UI access, feature visibility, and enforce security/authorization.
export const queryGetAuth = gql`query ent($auth: AuthInput) {
    getAuth(input: $auth) {
        access
        userId
        valid
        analytics
        viewType
        blockDeletion
        visibilityDetails
        visibilityDetailsTranscript
        visibilityDetailsAnalytics
        visibilityDetailsAnalyticsChange
        visibilityDetailsNotes
        visibilityDetailsTTL
        visibilityDetailsCustomFields
        visibilityDetailsMetadata
        visibilityDetailsQM
        visibilityDetailsAIAssistant
        visibilityDetailsAIAssistantHistory
        visibilityCleanUp
        visibilityExport
        availableAIAssistant
        availableOpenQuestion
        availableOpenQuestionLogging
        aiAssistantLanguage
        userTemplateAllowed
        license
        historyVault
        showTicketPage
        isAscUser
        addOnCompliance
        addOnQualityManagement
        addOnCaseManagement
        addOnAIEntry
        pinnedDashboard
        ruleAnalytics {
            withSentiment
            withTranscription
            transcriptLanguage
            translationType
            translationLanguage
            screenAnalysis
            denyDefaultChange
            defaultNotTranscribe
            multilingualConversations
            optionAlternativeLanguageKey
            accessType
            transcriptType
            transcriptModelWhisper
        }
        ruleAccess {
            userLiveView
            userDenyExport
            userDenyUpload
            userBulkExport
            userBulkRestoreArchive
            userBulkSafe
            userBulkSafeAdd
            userBulkSafeRemove
            userBulkCase
            userBulkCaseAdd
            userBulkCaseRemove
            userBulkDelete
            userBulkTranscript
            userBulkExcel
            userBulkIpRange
            userBulkPasswordLength
            userSafe
            userReporting
            tenantCreate
            tenantChange
            confListUser
            confAddUser
            confTicket
            confTenants
            confUserConfig
            confRulesRecording
            confRulesReplay
            confRulesAccess
            confRulesAnalytics
            confMapUser
            confUserAssignment
            confAssignRecording
            confAssignReplay
            confAssignAccess
            confAssignAnalytics
            userAssignmentUsers
            userKpiWallboard
            userAllowSharing
            confAuditLogs
            confJobs
            confCustomFields
            confAdministrateCustomFields
            confDefineActionOnCustomFields
            hasCustomFieldsAccess
            customFieldsAccessType
            customFieldsEditableTime
            accesibleCustomFields
            groupFeature
            denyReportAlarming
            allowConvSharing
            complianceResultsAccess
            complianceQMResultsAccess
            userCompliancePolicy
            userCompliancePolicyActivate
            userCompliancePolicyInitiateWorkflow
            userCompliancePolicyEdit
            userCompliancePolicyAssign
            userComplianceAIQuestions
            userComplianceQM
            userComplianceAIAssistant
            editableTimeCustomFields
            cfDisableTagging
            allowTTLChangeViaCategorization
            suspensionConvDelProcess
            allowManualMuting
            allowAiQuestionsWithoutCompliance
            confProfiles
            isUsedForCaseManagement
            archivedRequestRetrievalReasoningRequired
            ownFolder{
                addConversations 
                editFolder
                removeConversations 
                upserFolder 
                userIds 
                exportFolders
                deleteFolders
                shareFolders
            }
        }
        ruleRecording {
            audioType
            inboundType
            disableNextRecording
            disableNextRecordingReasonRequired
            disableNextRecordingReasons
            demandStartOnly
            keepDeleteSettings{
            type
            startMode
            hasWrapUp
            wrapUpTimer
            isWrapUpOnly
            recordingMode
            actions
            hasPopupAlert
            isSendToDo
            toDoTimer
            hasUserNotification
            specificSettings
            isActive
            }
            roDStopReasons
            roDStopReasonRequired
        }
        defaultFilter {
            id
            timeBasedType
            type
            cycle
            startDate
            endDate
            categories
            integrations
            application
            imports
            persons
            recordingOwner
            durationFrom
            durationTo
            incidentStatus
        }
        recordingFilter {
            id
            type
            cycle
            startDate
            endDate
            persons
            defaultFilter
            userFilter
            categories
            policies
            integrations
            application
            imports
            folders
            timeBasedType
            recordingOwner
            durationFrom
            durationTo
            incidentStatus
        }
        ticketFilter {
           cycle
           startDate
           endDate
           grabClosedTickets
           state
        }
        allowedTenants {
            name
            id
        }
    }
}
`;

// Fetches all configuration data for the current tenant/user, including integrations, storage, user profiles, rules, and more.
// Used to populate the main settings/configuration UI with all relevant backend data in a single request.
export const queryGetConfigData = gql`
    query ent($auth: AuthInput) {
        getConfigData(input: $auth) {
            tenant {
                licenseComp {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseCompAna {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseSmart {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseSmartAna {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseAna {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseCompVoice {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseCompVoiceAna {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseSmartVoice {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseSmartVoiceAna {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseRecordingInsinghtsAI {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseSmartBase {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                licenseComplianceBase {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
                 licenseEntryVoiceRecording {
                    bought
                    used
                    id
                    type {
                        id
                    }
                }
              
                packageStorage
                packageAnalyticsVideo
                packageAnalyticsSpeech
                packageAnalyticsTranscript
                packageAnalyticsBatchTranscript
                packageAnalyticsTranslate
                packageAnalyticsAI
                analyticsVideoCapacity
                analyticsVideoCapacityUsed
                analyticsSpeechCapacity
                analyticsSpeechCapacityUsed
                analyticsTranscriptCapacity
                analyticsTranscriptCapacityUsed
                analyticsBatchTranscriptCapacity
                analyticsBatchTranscriptCapacityUsed
                analyticsTranslateCapacity
                analyticsTranslateCapacityUsed
                addOnAnalytics
                addOnAnalyticsUsed
                addOnAIEntry
                addOnAIEntryUsed
                addOnFullChat
                addOnFullChatUsed
                addOnZoom
                addOnZoomUsed
                addOnGenesys
                addOnGenesysUsed
                addOnRingcentral
                addOnRingcentralUsed
                addOnCloud9
                addOnCloud9Used
                addOnDynamics
                addOnDynamicsUsed
                addOnCompliance
                addOnComplianceUsed
                addOnQualityManagement
                addOnQualityManagementUsed
                addOnRealTimeTranscript
                addOnRealTimeTranscriptUsed
                addOnLeapXpert
                addOnLeapXpertUsed
                addOnWebex
                addOnWebexUsed
                addOnEmail
                addOnEmailUsed
                addOnMsftTeamsVoice
                addOnMsftTeamsVoiceUsed
                addOnMsftTeamsUC
                addOnMsftTeamsUCUsed
                addOnN1Mapping
                packageExport
                storage
                analyticsAICapacityUsed
                analyticsAICapacity
                storageId
                syncEmployeeDataFromGraph
                audioStorage {
                  archiveBlobs
                }
            }
    
            userdata {
                access
                department
                name
                recordingRules
                replay
                analytics
                username
                id
                userId
                license
                groupId
                groupName
                addOnAnalytics
                addOnAIEntry
                addOnFullChat
                addOnZoom
                addOnGenesys
                addOnRingcentral
                addOnCloud9
                addOnDynamics
                addOnCompliance
                addOnEmail
                addOnQualityManagement
                addOnCaseManagement
                addOnLeapXpert
                addOnWebex
                addOnMsftTeamsVoice
                addOnMsftTeamsUC
                addOnRealTimeTranscript
                regionalStorageLocation
                regionalStorageCustomLocation
                integrationUser
                awsAccessKeyId
                awsSecretAccess
                awsBucketName
                awsRegion
                awsServiceUrl
                awsType
                storageId
                groupMembership
                employeeId
                onPremisesSamAccountName
            }
            groupdata {
                tenantId
                adGroupId
                id
                recordingRules
                replay
                analytics
                access
                license
                name
                priority
                addOnAnalytics
                addOnAIEntry
                addOnFullChat
                addOnZoom
                addOnGenesys
                addOnRingcentral
                addOnCloud9
                addOnDynamics
                addOnCompliance
                addOnQualityManagement
                addOnRealTimeTranscript
                addOnCaseManagement
                addOnLeapXpert
                addOnWebex
                addOnEmail
                addOnMsftTeamsVoice
                addOnMsftTeamsUC
                regionalStorageLocation
                regionalStorageCustomLocation
                awsAccessKeyId
                awsSecretAccess
                awsBucketName
                awsRegion
                awsServiceUrl
                awsType
                storageId
            }
            ruledata {
                created
                group
                id
                name
                usage
                isEntryVoiceOnly
            }
            userprofiles {
              id
              name
              tenantId
              rules
              recReevaluateChangeFromOneToOneToMeeting
              disableNextRecording
              disableNextRecordingReasonRequired
              disableNextRecordingReasons
              userStreamOnly
              useOnBehalfOfUserSetting
              hasDtmfSettings
              isDtmfEnabled
              start
              stop
              isDtmfAnnouncementSuppressionEnabled
              announcementSuppressionCode
              announcementSuppressionTimeInDays
              chat
              chatType
              channelType
              chatTypeDeny
              chatTypeDenyList
              announcementInChat
              chatTtl
              mail
              mailTtl
              internalParticipants
              externalParticipants
              selectedChannel
              channelList
              text
              announcementType
              announcementSetting
              enableBeepTone
              beepToneDelay
              timezone
              trackOnDemandDecision
              ruleDecisionTracking
              isEntryVoiceOnly
              callQueueRuleOverride
              recordSeparateSpeakers
              announcements {
                  prefixList
                  start
                  stop
              }
            }
            userprofilerules{
                id
                tenantId
                name
                text
                announcementType
                announcementSetting
                enableBeepTone
                beepToneDelay
                isEntryVoiceOnly
                callQueueRuleOverride
                announcements {
                    prefixList
                    start
                    stop
                }
                filters {
                    lists {
                        type
                        entries
                        matchMode
                        isActive
                    }
                    statistics {
                        useStatistics
                        statisticsRecordingType
                        amountOfConversationsToRecord
                        recordingInterval
                        useSchedulingFilter
                    }
                    conversationType
                    schedulingFilter {
                        hasDurationFilter
                        duration {
                            min
                            max
                        }
                        timetable {
                            daily {
                                start
                                stop
                            }
                            weekly {
                                days
                                start
                                stop
                            }
                            monthly {
                                quantifier
                                days
                                start
                                stop
                            }
                        }
                    }
                    recordingType {
                        recAudioType
                        bulk {
                            hasStartStops
                            startStops
                            stopReasonRequired
                            stopReasons
                            recordingStartsAfter
                            recordingDelayEnabled
                        }
                        rod {
                            hasStartStops
                            stopReasonRequired
                            stopReasons
                            startStops
                        }
                        recordingControl {
                            hasStartStops
                            recordingStartsAfter
                            startStops
                            autoStartRecording
                            stopReasonRequired
                            stopReasons
                        }
                        media {
                            ttl
                            ttlType
                            metadata {
                                isActive
                                ttl
                                isRod
                            }
                            audio {
                                isActive
                                ttl
                                isRod
                            }
                            video {
                                isActive
                                ttl
                                isRod
                            }
                            screen {
                                isActive
                                ttl
                                isRod
                            }
                           
                        }
                        startMode
                        hasKeepDelete
                        wrapUp
                        hasWrapUp
                    }
                }
            }
            categorydata {
                tenantId
                name
                id
                frequence
                sentiment
                keywords
                link
                searchExactKeywords
                countUniqueWordsOnce
                fromCompliance
                categorizationActionType
                retentionTimeSetting
                version
                masterItemId
                selected
                categoryGroup {
                    id
                    name
                    description
                    tenantId
                    generalGroup
                }
            }
            customfieldsdata {
                tenantId
                fieldName
                isNumeric
                isAlphanumeric
                maxNumberOfFields
                fieldLength
                hasExactLength
                isCheckbox
                id
                hasTriggerAction
                actionType
                ttlSettingYes
                ttlSettingNo
                notifications
                mapping
                hasAdditionalNumberCheck
                numberCheckAlgorithmType
            }
            storagedata {
                id
                tenantId
                displayName
                storageAccountName
                isActive
                visibleForAssignment
                group
                storageLocation
                storageUsed
                storageType
                awsRegion
                awsAccessKeyId
                awsSecretAccess
                awsBucketName
                awsServiceUrl
                awsType
                useRegionalEncryption
                keyVaultUrl
                secretName
                isAsymmetric
                isHistorical
                keyVaultName
                disablePayloadSigning
                archiving

            }
            importdata {
                id
                name
                callStartTime
                callEndTime
                jobType {
                    intervalDay
                    intervalHour
                    intervalMinute
                    intervalMonth
                    intervalType
                    jobStartTime
                }
                mappingType
                mappingUserId
                importType
                keyVaultConnectionString
                sourceTtl
                targetTtl
                enabled
                processingRegion
                storageConnectionString
                storageContainerName
                storageRootDirectory
                tenantId
                hasSftpKey
                state
                nextRun
                lastSuccessfulRun
                numberOfConversations
                remainingPackageSize
                isArchived
                userIds
                totalCalls
                transferId
                customFieldMapping
                metadataMapping
                mappingFiles
                createUnmixedEnhancement            
            }
            integrationdata {
                id
                name
                integrationType
                enabled
                processingRegion
                fetchCycleDay
                fetchCycleHour
                fetchCycleMinute
                fetchStartDateTime
                integrationClientId
                integrationClientSecret
                integrationUsername
                integrationPassword
                tenantId
                syncRecordingRule
                allRecordings
                splitAudioInAgentSegments
                daysUntilDeletion
                mappingUserId
                folderName
                leapXpertUserMappingField
                ttlCustomFieldMapping {
                    sourcekey
                    sourcevalue
                    customfieldId
                }
                filterAttribute
                {
                    key
                    value
                }
                dynamicsCallObjectOpen
                archiveDynamicsCC
                genesysReportCustomField         
                customFieldMappings
                webexEnabledStorageRegions
                awsRegion
                cloud9AudioFormat
            }
            exportdata {
                id
                name
                userIds
                jobType {
                    intervalDay
                    intervalHour
                    intervalMinute
                    intervalMonth
                    intervalType
                    jobStartTime
                }
                exportType
                sourceTtl
                storageConnectionString
                storageContainerName
                storageRootDirectory
                audioCodec
                callStartTime
                callEndTime
                conversationType
                policyResultType
                tenantId
                processingRegion
                enabled
                defaultRegion
                pgpEncryption
                hasSftpKey
                auditEventTypes
                state
                nextRun
                lastSuccessfulRun
                numberOfConversations
                remainingPackageSize
                isArchived
                mergeAudioToVideo
                metadataInTranscript
                filterType
                durationFrom
                durationTo
                participantCountFrom
                participantCountTo
                totalCalls
                transferId
                encryptionKeyVaultUrl
                customFieldKey
                customFieldValue
                isCustomFieldEqual
                conversationClientId
                conversationClientSecret
                voiceClientId
                voiceClientSecret
                subTypeMapping
                sftpPrivateKeyKeyVaultUrl
                sftpPrivateKeyKeyVaultSecretName
                exportMetadata
            }
            reportdata {
                id
                title
                widget
                text
                type
                kpi
                tenantId
                valueType
                startDate
                endDate
                position {
                    w
                    h
                    x
                    y
                }
                cycle
                keywords
                tForm
                categories
                alarming {
                    mail
                    eventType
                    value
                    alarmActive
                }
                persons {
                    userId
                    name
                    id
                }
            }
            policydata {
                id
                name
            }
        }
    }
`

export const queryGetRuleData = gql`
    query ent($auth: AuthInput) {
        getRuleData(input: $auth) {
            ruledata {
                created
                group
                id
                name
                usage
                isEntryVoiceOnly
            }
        }
    }
`;


export const queryGetUser = gql`
    query ent ($auth:AuthInput, $isAllowList:Boolean){
        getUserData(input:$auth, isAllowList:$isAllowList)
        {
            userdata
            {
                name
                username
                id
                userId
                members
                addOnCompliance
                addOnQualityManagement
                license
            }

        }
    }
`;

export const queryGetRuleRecording = gql`
    query ent ($id : ID!, $auth:AuthInput ){
        getRuleRecording(input:$auth, id: $id)
        {
            id
            name
            tenantId
            group
            text
            time
            audio
            video
            screenOnly
            chat
            mail
            audioType
            chatType
            chatTypeDeny
            channelType
            areaCode
            inboundType
            outboundType
            meetingType
            meetingExternalType
            meetingInternalType
            internalType
            silentRecording
            meetingOrganizer
            meetingParticipant
            meetingSubjectAllowList
            meetingSubjectDenyList
            allowList
            denyList
            useOnBehalfOfUserSetting
            switchInitialState
            disableNextRecording
            disableNextRecordingReasonRequired
            disableNextRecordingReasons
            trackOnDemandDecision
            ruleDecisionTracking
            userStreamOnly
            demandStartOnly
            pstnAnnouncement
            ascBeeptone
            ascBeeptoneFrequency
            announcementType
            announcements
            start
            stop
            isDtmfEnabled
            isDtmfAnnouncementSuppressionEnabled
            announcementSuppressionCode
            announcementSuppressionTimeInDays
            recReevaluateChangeFromOneToOneToMeeting
            channelList
            roDStopReasons
            roDStopReasonRequired
            recordingTransferorAllowList
            recordingTransferorDenyList
            isEntryVoiceOnly
            callQueueRuleOverride
            recordSeparateSpeakers
            keepDeleteSettings{
            type
            startMode
            hasWrapUp
            wrapUpTimer
            isWrapUpOnly
            recordingMode
            actions
            hasPopupAlert
            isSendToDo
            toDoTimer
            hasUserNotification
            specificSettings
            isActive
            }
        }
    }
`;

export const queryGetRuleReplay = gql`
    query ent ($id : ID!, $auth:AuthInput ){
        getRuleReplay(input:$auth, id: $id)
        {
            id
            name
            tenantId
            group
            text
            replay
            visibility
            visibilityUser
            replayUser
            visibilityDetails
            visibilityDetailsTranscript
            visibilityDetailsAnalytics
            visibilityDetailsAnalyticsChange
            visibilityDetailsNotes
            visibilityDetailsTTL
            visibilityDetailsCustomFields
            visibilityDetailsMetadata
            visibilityDetailsQM
            visibilityDetailsAIAssistant
            visibilityCleanUp
            availableAIAssistant
            availableOpenQuestion
            availableOpenQuestionLogging
            aiAssistantLanguage
            visibilityDetailsAIAssistantHistory
            replayCycle
            replayReasons
            recordingFilter {
               id
               type
               cycle
               startDate
               endDate
               categories
               integrations
               application
               imports
               persons
               timeBasedType
               durationFrom
               durationTo
               recordingOwner
               defaultFilter
            }
        }
    }
`;

export const queryGetRuleAccess = gql`
    query ent ($id : ID!, $auth:AuthInput ){
        getRuleAccess(input:$auth, id: $id)
        {
            id
            name
            tenantId
            group
            text
            confListUser
            confAddUser
            confTicket
            confTenants
            confUserConfig
            confRulesRecording
            confRulesReplay
            confRulesAccess
            confRulesAnalytics
            confMapUser
            confUserAssignment
            confAssignRecording 
            confAssignReplay
            confAssignAccess
            confAssignAnalytics 
            confAuditLogs
            confJobs
            confCustomFields
            confAdministrateCustomFields
            confDefineActionOnCustomFields
            hasCustomFieldsAccess
            customFieldsAccessType
            customFieldsEditableTime
            accesibleCustomFields
            cfDisableTagging
            userReporting
            userKpiTotal
            userKpiIncoming
            userKpiOutgoing
            userKpiKeywords
            userKpiWallboard
            userAllowSharing
            userSafe
            isUsedForCaseManagement
            userSafeAdd
            userSafeExport
            userSafeShare
            ownFolder{
                addConversations
                removeConversations
                upserFolder
                editFolder
                userIds 
                exportFolders
                deleteFolders
                shareFolders
            }
            userDelete
            userPropose
            userProposeReasoning
            userEmailNotification
            userProposeUsers
            userSafeUsers
            userAssignmentUsers 
            userLiveView
            userDenyExport
            userDenyUpload
            userBulkExport
            userBulkRestoreArchive
            userBulkSafe
            userBulkSafeAdd
            userBulkSafeRemove
            userBulkCase
            userBulkCaseAdd
            userBulkCaseRemove
            userBulkDelete
            userBulkTranscript
            userBulkExcel
            userBulkIpRange
            userBulkPasswordLength
            complianceResultsAccess
            complianceQMResultsAccess
            userCompliancePolicy
            userCompliancePolicyActivate
            userCompliancePolicyInitiateWorkflow
            userCompliancePolicyEdit
            userCompliancePolicyAssign
            userComplianceAIQuestions
            userComplianceQM
            userComplianceAIAssistant
            denyReportAlarming
            allowConvSharing
            archivedConversationAccessType
            archivedRequestRetrievalReasoningRequired
            approvedUsersReplay
            editableTimeCustomFields
            allowTTLChangeViaCategorization
            suspensionConvDelProcess
            accMergeAudioToVideo
            allowManualMuting
            allowAiQuestionsWithoutCompliance
            confProfiles
        }
    }
`;

export const queryGetRuleAnalytics = gql`
    query ent ($id : ID!, $auth:AuthInput ){
        getRuleAnalytics(input:$auth, id: $id)
        {
            id
            name
            tenantId
            group
            text
            accessType
            startTime
            endTime
            withTranscription
            transcriptLanguage
            withSentiment
            keywordCategories
            entityCategories                      
            keyphraseExtraction 
            translationType
            userVisible
            onDemandSpeech2Text 
            onDemandKeywords
            onDemandEntities
            individualKeywords
            translationLanguage 
            keywordList
            optionAlternativeLanguageKey
            multilingualConversations
            analyzeAllConditions
            hasSpeakerRecognition
            denyDefaultChange
            defaultNotTranscribe
            screenAnalysis
            policies
            transcriptType
            transcriptModelWhisper
            aiSummaryQuestion
       }
    }
`;

export const queryGetNewsList = gql`
                          query ent ($id: String, $auth:AuthInput) {
                            getNewsList(id: $id,input:$auth) {
                                id
                                date
                                time
                                title
                                priority
                                text
                            }
                          }
                        `;

export const queryGetEmailList = gql`
                          query ent ($id: String, $tenantId: String, $auth:AuthInput) {
                            getEmailList(id: $id,tenantId: $tenantId, input:$auth) {
                                id
                                created
                                createdMs
                                changed
                                subject
                                to
                                from
                                text
                            }
                          }
                        `;

export const mutationDeleteNewsEntry = gql` mutation ent ($id : String!) { deleteNewsEntry (id: $id) }`;

export const mutationCreateNewsEntry = gql`
                          mutation ent ($news: NewsInputType){
                            createNewsEntry(news: $news)
                              }
                            `;



export const queryGetAudit = gql`
    query ent ($auth:AuthInput){
        getAuditData(input:$auth)
        {
            id
            name
            key
            group
        }
    }
`;

export const queryGetTickets = gql`
    query ent ($auth:AuthInput, $tenantId:String, $asPartner: Boolean, $filter:TicketFilterInputType, $withSave:Boolean){
        getTickets(input:$auth, tenantId: $tenantId, asPartner: $asPartner, filter: $filter, withSave: $withSave )
         {
            title
            userId
            priority
            created
            createdMs
            tenantId
            caseId
            changed
            changedMs
            description
            contactEmail
            id
            state
            closedDate
          }
   }
`;
export const queryGetTicketDocuments = gql`
                          query ent ($auth:AuthInput,$id: String, $tenantId:String, ){
                            getTicketDocuments(input:$auth, id: $id ,tenantId: $tenantId)
                                    {
                                    filename
                                    mimeType
                                    documentBody
                                    annotationId
                                    isDeleted
                                  }
                              }
                            `;

export const queryGetTenantList = gql`
                          query ent ($auth:AuthInput){
                            getTenantList(input:$auth)
                                    {
                                        tenantId
                                        name
                                        id
                                        adminId
                                        cloudTenantId
                                        storage
                                        storageId
                                        customStorage
                                        packageStorage
                                        packageAnalyticsVideo
                                        packageAnalyticsSpeech
                                        packageAnalyticsTranscript
                                        packageAnalyticsBatchTranscript
                                        packageAnalyticsTranslate
                                        packageAnalyticsAI
                                        analyticsVideoCapacity
                                        analyticsVideoCapacityUsed
                                        analyticsSpeechCapacity
                                        analyticsSpeechCapacityUsed
                                        analyticsTranscriptCapacity
                                        analyticsTranscriptCapacityUsed
                                        analyticsBatchTranscriptCapacity
                                        analyticsBatchTranscriptCapacityUsed
                                        analyticsTranslateCapacity
                                        analyticsTranslateCapacityUsed
                                        analyticsAICapacity
                                        analyticsAICapacityUsed
                                        addOnAnalytics
                                        addOnAnalyticsUsed
                                        addOnAIEntry
                                        addOnAIEntryUsed
                                        addOnFullChat
                                        addOnFullChatUsed
                                        addOnZoom
                                        addOnZoomUsed
                                        addOnGenesys
                                        addOnGenesysUsed
                                        addOnRingcentral
                                        addOnRingcentralUsed
                                        addOnCloud9
                                        addOnCloud9Used
                                        addOnDynamics
                                        addOnDynamicsUsed
                                        addOnCompliance
                                        addOnComplianceUsed
                                        addOnQualityManagement
                                        addOnQualityManagementUsed
                                        addOnRealTimeTranscript
                                        addOnRealTimeTranscriptUsed
                                        addOnLeapXpert
                                        addOnLeapXpertUsed
                                        addOnWebex
                                        addOnWebexUsed
                                        addOnEmail
                                        addOnEmailUsed
                                        addOnMsftTeamsVoice
                                        addOnMsftTeamsVoiceUsed
                                        addOnMsftTeamsUC
                                        addOnMsftTeamsUCUsed
                                        addOnN1Mapping
                                        packageExport
                                        packageImport
                                        domainRestrictionsList
                                        mailAlarming
                                        commercialContactMail
                                        storageContent
                                        contractNumber
                                        storageMax
                                        exportType
                                        exportStorage
                                        exportSizeUsed
                                        importSizeUsed
                                        reseller
                                        groupCallUsers
                                        type
                                        country
                                        partner
                                        partnerContract
                                        support
                                        bots {
                                            id
                                            name
                                            botAppId
                                            region
                                            linkId
                                            count
                                            hA
                                        }
                                        onboardingDate
                                        billingDate
                                        trainingDate
                                        supportNotes
                                        systemId
                                        tenantSuspensionConvDelProcess
                                        awsAccessKeyId
                                        awsSecretAccess
                                        awsBucketName
                                        awsRegion
                                        awsServiceUrl
                                        awsType
                                        archiveSizeUsed
                                        packageArchive
                                        licenseComp {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseCompAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmart {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseCompVoice {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseCompVoiceAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartVoice {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartVoiceAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseRecordingInsinghtsAI {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartBase {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseComplianceBase {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                         licenseEntryVoiceRecording {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                       
                                        keyManagementType
                                        keyManagement {
                                           rotationType
                                           intervalDays
                                           activationDelay
                                           willExpire
                                           expireDays
                                           keySecurity
                                           customEncryptionKeyVaultUrl
                                           customEncryptionKeySecretName
                                            asymmetricKeySettings {
                                                keyType
                                                keySetting
                                                asymmetricKeyFileName
                                            }
                                        asymmetricKeyEnabled
                                        }
                                        keyManagementEnabled
                                        chatModelA 
                                        showTicketPage
                                        audioStorage {
                                            id
                                            tenantId
                                            convertToMP3
                                            convertBlobOlderThanDays
                                            archiveBlobs
                                            archiveBlobOlderThanDays
                                            archiveDestinationAudioFormat
                                        }
                                        interactionLogging
                                        loggingStartDate
                                        loggingStopDate
                                        allowedUsers{
                                            id
                                            userId
                                            name
                                            username
                                            addOnCompliance
                                        }
                                        processingRegion
                                        eventHubNamespace
                                        eventHubName
                                        kafkaBootstrapServers
                                        kafkaTopic
                                        kafkaSecurityProtocol
                                        kafkaSslCaLocation
                                        kafkaSslCertificateLocation
                                        kafkaSslKeyLocation
                                        kafkaSslKeyPassword
                                        kafkaSaslMechanism
                                        kafkaSaslUsername
                                        kafkaSaslPassword
                                    }
                              }
                            `;

export const queryGetTenantData = gql`
                          query ent ($auth:AuthInput){
                            getTenantData(input:$auth)
                                    {
                                        tenantId
                                        name
                                        id
                                        adminId
                                        cloudTenantId
                                        storage
                                        customStorage
                                        packageStorage
                                        packageAnalyticsVideo
                                        packageAnalyticsSpeech
                                        packageAnalyticsTranscript
                                        packageAnalyticsBatchTranscript
                                        packageAnalyticsTranslate
                                        packageAnalyticsAI
                                        analyticsVideoCapacity
                                        analyticsVideoCapacityUsed
                                        analyticsSpeechCapacity
                                        analyticsSpeechCapacityUsed
                                        analyticsTranscriptCapacity
                                        analyticsTranscriptCapacityUsed
                                        analyticsBatchTranscriptCapacity
                                        analyticsBatchTranscriptCapacityUsed
                                        analyticsTranslateCapacity
                                        analyticsTranslateCapacityUsed
                                        analyticsAICapacity
                                        analyticsAICapacityUsed
                                        addOnAnalytics
                                        addOnAnalyticsUsed
                                        addOnAIEntry
                                        addOnAIEntryUsed
                                        addOnFullChat
                                        addOnFullChatUsed
                                        addOnZoom
                                        addOnZoomUsed
                                        addOnGenesys
                                        addOnGenesysUsed
                                        addOnRingcentral
                                        addOnRingcentralUsed
                                        addOnCloud9
                                        addOnCloud9Used
                                        addOnDynamics
                                        addOnDynamicsUsed
                                        addOnCompliance
                                        addOnComplianceUsed
                                        addOnQualityManagement
                                        addOnQualityManagementUsed
                                        addOnRealTimeTranscript
                                        addOnRealTimeTranscriptUsed
                                        addOnLeapXpert
                                        addOnLeapXpertUsed
                                        addOnWebex
                                        addOnWebexUsed
                                        addOnEmail
                                        addOnEmailUsed
                                        addOnMsftTeamsVoice
                                        addOnMsftTeamsVoiceUsed
                                        addOnMsftTeamsUC
                                        addOnMsftTeamsUCUsed
                                        addOnN1Mapping
                                        packageExport
                                        packageImport
                                        domainRestrictionsList
                                        mailAlarming
                                        commercialContactMail
                                        storageContent
                                        contractNumber
                                        storageMax
                                        exportType
                                        exportStorage
                                        exportSizeUsed
                                        importSizeUsed
                                        reseller
                                        type
                                        country
                                        partner
                                        partnerContract
                                        support
                                        bots {
                                            id
                                            name
                                            botAppId
                                            region
                                            linkId
                                            count
                                            hA
                                        }
                                        onboardingDate
                                        billingDate
                                        trainingDate
                                        supportNotes
                                        systemId
                                        tenantSuspensionConvDelProcess
                                        awsAccessKeyId
                                        awsSecretAccess
                                        awsBucketName
                                        awsRegion
                                        awsServiceUrl
                                        awsType
                                        archiveSizeUsed
                                        packageArchive
                                        licenseComp {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseCompAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmart {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseCompVoice {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseCompVoiceAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartVoice {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartVoiceAna {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseRecordingInsinghtsAI {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseSmartBase {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                        licenseComplianceBase {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                         licenseEntryVoiceRecording {
                                            bought
                                            used
                                            id
                                            type {
                                                id
                                            }
                                        }
                                       
                                        keyManagementType
                                        keyManagement {
                                           rotationType
                                           intervalDays
                                           activationDelay
                                           willExpire
                                           expireDays
                                           keySecurity
                                           customEncryptionKeyVaultUrl
                                           customEncryptionKeySecretName
                                            asymmetricKeySettings {
                                                keyType
                                                keySetting
                                                asymmetricKeyFileName
                                            }
                                        asymmetricKeyEnabled
                                        }
                                        keyManagementEnabled
                                        chatModelA
                                        showTicketPage
                                        audioStorage {
                                            id
                                            tenantId
                                            convertToMP3
                                            convertBlobOlderThanDays
                                            archiveBlobs
                                            archiveBlobOlderThanDays
                                            archiveDestinationAudioFormat
                                        }
                                      
                                    }
                              }
                            `;


export const mutationCreateTenant = gql`
                          mutation ent ($auth:AuthInput, $tenant:TenantInputType, $createSubUnit:Boolean){
                            createTenant(input:$auth, tenant: $tenant, createSubUnit: $createSubUnit)
                                    {
                                        tenantId
                                        name
                                        id
                                        adminId
                                        text
                                    }
                              }
                            `;

export const mutationUpdateTenant = gql`
                          mutation ent ($auth:AuthInput, $tenant:TenantInputType){
                            updateTenant(input:$auth, tenant: $tenant)
                                    {
                                        tenantId
                                        name
                                        id
                                        adminId
                                        text
                                    }
                              }
                            `;

export const mutationCreateTicket = gql`
                          mutation ent ($ticket:ServiceTicketInputType){
                            createTicket(ticket: $ticket)
                              }
                            `;

export const mutationCreateTicketComment = gql`
                          mutation ent ($ticket:ServiceTicketInputType, $comment: String){
                            createTicketComment(ticket: $ticket, comment: $comment)
                              }
                            `;

export const mutationUpdateTicket = gql`
                          mutation ent ($ticket:ServiceTicketInputType){
                            updateTicket(ticket: $ticket)
                          }
                            `;

export const mutationUpdateAudioStorage = gql`
                          mutation ent ($auth:AuthInput, $audioStorage:AudioStorageInputType){
                            updateAudioStorage(input:$auth, audioStorage: $audioStorage)
                                    {
                                        tenantId
                                        id
                                    }
                              }
                            `;

export const mutationWriteAuditEvent = gql`
                          mutation ent ($key:String, $id:String, $text: String){
                            writeAuditEvent(auditEvent: {key: $key, conversationId: $id, text: $text})
                          }
                            `;


export const mutationDeleteBot = gql`
                         mutation ent ($auth:AuthInput, $id:String){
                            deleteBot(input:$auth, id: $id)
                                    {
                                          id
                                    }
                              }
                            `;

export const mutationDeleteGroup = gql`
                         mutation ent ($auth:AuthInput, $id:String){
                            deleteGroup(input:$auth, id: $id)
                                    {
                                          id
                                    }
                              }
                            `;

export const mutationDeleteUser = gql`
                         mutation ent ($auth:AuthInput, $id:[String]){
                            deleteUser(input:$auth, id: $id)
                                    {
                                          id
                                          name
                                    }
                              }
                            `;

export const mutationCreateUser = gql`
                         mutation ent ($auth:AuthInput, $user:[UserDataInput]){
                            createUser(input:$auth, user: $user)
                                    {
                                            name
                                            access
                                    }
                              }
                            `;

export const mutationCreateGroup = gql`
                         mutation ent ($auth:AuthInput, $group:[GroupInputType]){
                            createGroup(input:$auth, group: $group)
                                    {
                                            name
                                            access
                                    }
                              }
                            `;

export const mutationBulkImport = gql`
                         mutation ent ($auth:AuthInput, $user:[UserDataInput], $tenantId: String){
                            bulkImport(input:$auth, user: $user, tenantId: $tenantId)
                              }
                            `;

export const deleteTenant = gql`
                         mutation ent ($auth:AuthInput, $tenantId: String){
                            deleteTenant(input:$auth, tenantId: $tenantId)
                                   
                              }
                            `;

export const deleteTenantMetadataQuery = gql`
                         mutation ent ($auth:AuthInput, $tenantId: String, $date: DateTime){
                            deleteTenantRecordings(input:$auth, tenantId: $tenantId, date: $date)
                                   
                              }
                            `;

export const checkTenantForDeletion = gql`
                            mutation ent ($auth:AuthInput, $tenantId: String){
                                checkTenantForDeletion(input:$auth, tenantId: $tenantId)

                                }
                                `;
export const insertMessage = gql`
                         mutation ent ($auth:AuthInput, $message: String){
                            insertMessage(input:$auth, message: $message)
                                   
                              }
                            `;

export const userGroupSync = gql`
                         mutation ent ($auth:AuthInput){
                            userGroupSync(input:$auth)                                   
                              }
                            `;

export const changeEncryptionKey = gql`
                         mutation ent {
                            changeEncryptionKey                                  
                              }
                            `;

export const checkCustomKeyVault = gql`
                         mutation ent ($auth:AuthInput, $customKeyVaultUrl:String, $customSecretName: String, $isAsymmetric:Boolean){
                            checkCustomKeyVault(input:$auth, customKeyVaultUrl:$customKeyVaultUrl, customSecretName: $customSecretName, isAsymmetric:$isAsymmetric)
                                   
                              }
                            `;
export const checkEventHubUrlValidity = gql`
                            mutation ent ($auth:AuthInput, $eventHubNamespace:String, $eventHubName:String){
                            checkEventHubUrlValidity(input:$auth, eventHubNamespace:$eventHubNamespace, eventHubName:$eventHubName)
                            }
                            `;
export const checkKafkaUrlValidity = gql`
                            mutation ent ($auth:AuthInput, $kafkaBootstrapServers:String, $kafkaTopic:String, $kafkaSecurityProtocol:String, $kafkaSslCaLocation:String, $kafkaSslCertificateLocation:String, $kafkaSslKeyLocation:String, $kafkaSslKeyPassword:String, $kafkaSaslMechanism:String, $kafkaSaslUsername:String, $kafkaSaslPassword:String){
                            checkKafkaUrlValidity(input:$auth, kafkaBootstrapServers:$kafkaBootstrapServers, kafkaTopic:$kafkaTopic, kafkaSecurityProtocol:$kafkaSecurityProtocol, kafkaSslCaLocation:$kafkaSslCaLocation, kafkaSslCertificateLocation:$kafkaSslCertificateLocation, kafkaSslKeyLocation:$kafkaSslKeyLocation, kafkaSslKeyPassword:$kafkaSslKeyPassword, kafkaSaslMechanism:$kafkaSaslMechanism, kafkaSaslUsername:$kafkaSaslUsername, kafkaSaslPassword:$kafkaSaslPassword)
                            }
                            `;
export const checkMaxRetentionTimeSettings = gql`
                         mutation ent ($auth:AuthInput, $tenantId: String){
                            checkMaxRetentionTimeSettings(input:$auth, tenantId: $tenantId)
                                   
                              }
                            `;
export const createCustomKeySecret = gql`
                         mutation ent ($auth:AuthInput, $customKeyVaultUrl:String, $customSecretName: String){
                            createCustomKeySecret(input:$auth, customKeyVaultUrl:$customKeyVaultUrl, customSecretName: $customSecretName)
                                   
                              }
                            `;
export const checkStorageAccountName = gql`
                         mutation ent ($auth:AuthInput, $storageAccountName:String){
                            checkStorageAccountName(input:$auth, storageAccountName:$storageAccountName)
                                   
                              }
                            `;
export const mutationCreateCategory = gql`
                         mutation ent ($auth:AuthInput, $category:CategoryInput){
                            createCategory(input:$auth, category: $category)
                                    {
                                          name
                                    }
                              }
                            `;

export const mutationCreateCategoryTemplate = gql`
                         mutation ent ($auth:AuthInput, $category:CategoryInput){
                            createCategoryTemplate(input:$auth, category: $category)
                                    {
                                          name
                                    }
                              }
                            `;

export const mutationUpdateCategory = gql`
                         mutation ent ($auth:AuthInput, $category:CategoryInput){
                            updateCategory(input:$auth, category: $category)
                                    {
                                          name
                                          id
                                    }
                              }
                            `;

export const mutationUpdateCategoryTemplate = gql`
                         mutation ent ($auth:AuthInput, $category:CategoryInput){
                            updateCategoryTemplate(input:$auth, category: $category)
                                    {
                                          name
                                          id
                                    }
                              }
                            `;


export const queryGetAllUsers = gql`
                         query ent ($auth:AuthInput, $filter:String){
                            getAllUsers(input:$auth,filter:$filter)
                                    {
                                          access
                                          department
                                          name
                                          recordingRules
                                          replay
                                          analytics
                                          username
                                          userId
                                     }
                              }
                            `;

export const queryGetAllGroups = gql`
                         query ent ($auth:AuthInput, $filter:String){
                            getAllGroups(input:$auth,filter:$filter)
                                    {
                                          access
                                          name
                                          recordingRules
                                          replay
                                          analytics
                                          adGroupId
                                     }
                              }
                            `;

export const mutationUpdateUser = gql`
                         mutation ent ($auth:AuthInput, $user: [UserDataInput]){
                            updateUser(input:$auth, user: $user)
                                    {
                                          name
                                    }
                              }
                            `;

export const mutationResetUser = gql`
                         mutation ent ($auth:AuthInput, $user: [UserDataInput]){
                            resetUser(input:$auth, user: $user)
                                    {
                                          name
                                    }
                              }
                            `;

export const mutationUpdateGroup = gql`
                         mutation ent ($auth:AuthInput, $group: [GroupInputType]){
                            updateGroup(input:$auth, group: $group)
                                    {
                                          name
                                    }
                              }
                            `;

export const mutationUpdateBot = gql`
                         mutation ent ($auth:AuthInput, $bot: BotInputType){
                            updateBot(input:$auth, bot: $bot)
                                    {
                                          name
                                    }
                              }
                            `;

export const mutationCreateRule = gql`
                         mutation ent ($auth:AuthInput, $name:String, $group:String, $visibility:String, $replay:String, $time:String, $text:String){
                            createRule(input:$auth, rule: {name: $name, group: $group, text: $text, replay: $replay, visibility: $visibility, time: $time})
                                    {
                                          name
                                     }
                              }
                            `;

export const mutationDeleteRuleAccess = gql`
                         mutation ent ($id:String){
                            deleteRuleAccess(id: $id)
                                    {
                                          name
                                     }
                              }
                            `;
export const mutationDeleteRuleRecording = gql`
                         mutation ent ($id:String){
                            deleteRuleRecording(id: $id)
                                    {
                                          name
                                     }
                              }
                            `;
export const mutationDeleteRuleReplay = gql`
                         mutation ent ($id:String){
                            deleteRuleReplay(id: $id)
                                    {
                                          name
                                     }
                              }
                            `;
export const mutationDeleteRuleAnalytics = gql`
                         mutation ent ($id:String){
                            deleteRuleAnalytics(id: $id)
                                    {
                                          name
                                     }
                              }
                            `;

export const mutationCreateRuleRecording = gql`
                         mutation ent ($auth:AuthInput, $name:String, $group:String, $time:String, $text:String, $audio:Boolean, $video: Boolean, $screenOnly: Boolean, $chat: Boolean, $mail: Boolean, $audioType: String, $chatType: String, $chatTypeDeny: Boolean, $channelType: String, $areaCode: String, $inboundType: String, $outboundType: String, $meetingType: String, $meetingExternalType: String, $meetingInternalType: String, $internalType: String, $silentRecording: Boolean, $allowList: String, $denyList: String, $meetingOrganizer: String, $meetingParticipant: String, $useOnBehalfOfUserSetting: Boolean, $switchInitialState: Boolean,$disableNextRecording: Boolean, $userStreamOnly: Boolean, $pstnAnnouncement: Boolean, $ascBeeptone:Boolean, $ascBeeptoneFrequency:Int, $announcementType:String, $announcements: String, $deletedFilesFromAnnouncements:[String], $start:String, $stop:String, $isDtmfEnabled: Boolean, $isDtmfAnnouncementSuppressionEnabled:Boolean, $announcementSuppressionCode:String, $announcementSuppressionTimeInDays:Int,
                         $recReevaluateChangeFromOneToOneToMeeting: Boolean, $channelList: String, $demandStartOnly: Boolean,$roDStopReasons:String, $roDStopReasonRequired:Boolean,$keepDeleteSettings:[RecordingKeepDeleteSettingInputType],$recordingTransferorAllowList:String, $recordingTransferorDenyList:String, $meetingSubjectAllowList:String, $meetingSubjectDenyList:String, $disableNextRecordingReasonRequired:Boolean, $disableNextRecordingReasons:String, $trackOnDemandDecision:Boolean, $isEntryVoiceOnly:Boolean, $callQueueRuleOverride:Boolean, $recordSeparateSpeakers:Boolean, $ruleDecisionTracking:Boolean){
                            createRuleRecording(input:$auth, rule: {name: $name, group: $group, text: $text, time: $time, audio: $audio, video: $video, screenOnly: $screenOnly, chat: $chat, mail: $mail, audioType: $audioType, chatType: $chatType, chatTypeDeny: $chatTypeDeny, channelType: $channelType, areaCode: $areaCode, inboundType: $inboundType, outboundType: $outboundType, meetingType: $meetingType, meetingExternalType: $meetingExternalType, meetingInternalType: $meetingInternalType, internalType: $internalType, silentRecording: $silentRecording, allowList: $allowList, denyList: $denyList, meetingOrganizer: $meetingOrganizer, meetingParticipant: $meetingParticipant, useOnBehalfOfUserSetting:$useOnBehalfOfUserSetting, switchInitialState: $switchInitialState, disableNextRecording: $disableNextRecording, userStreamOnly: $userStreamOnly, pstnAnnouncement: $pstnAnnouncement, ascBeeptone:$ascBeeptone, ascBeeptoneFrequency:$ascBeeptoneFrequency,announcementType: $announcementType, announcements:$announcements, deletedFilesFromAnnouncements:$deletedFilesFromAnnouncements, start:$start, stop:$stop, isDtmfEnabled:$isDtmfEnabled, isDtmfAnnouncementSuppressionEnabled:$isDtmfAnnouncementSuppressionEnabled, announcementSuppressionCode:$announcementSuppressionCode, announcementSuppressionTimeInDays:$announcementSuppressionTimeInDays, recReevaluateChangeFromOneToOneToMeeting:$recReevaluateChangeFromOneToOneToMeeting, channelList: $channelList, demandStartOnly: $demandStartOnly,roDStopReasons:$roDStopReasons, roDStopReasonRequired:$roDStopReasonRequired,keepDeleteSettings:$keepDeleteSettings, recordingTransferorAllowList:$recordingTransferorAllowList, recordingTransferorDenyList:$recordingTransferorDenyList, meetingSubjectAllowList:$meetingSubjectAllowList, meetingSubjectDenyList:$meetingSubjectDenyList, disableNextRecordingReasonRequired:$disableNextRecordingReasonRequired, disableNextRecordingReasons:$disableNextRecordingReasons, trackOnDemandDecision:$trackOnDemandDecision, isEntryVoiceOnly:$isEntryVoiceOnly, callQueueRuleOverride:$callQueueRuleOverride, recordSeparateSpeakers:$recordSeparateSpeakers, ruleDecisionTracking:$ruleDecisionTracking})

                                    {
                                          name
                                          text
                                     }
                              }
                            `;
export const mutationCreateRuleReplay = gql`
                         mutation ent ($auth:AuthInput, 
                            $name:String, 
                            $group:String, 
                            $visibility:String, 
                            $replay:String,  
                            $text:String, 
                            $visibilityUser:String, 
                            $replayUser:String, 
                            $replayCycle:String, 
                            $recordingFilter:RecordingFilterInputType,
                            $visibilityDetails: Boolean,
                            $visibilityDetailsTranscript: Boolean,
                            $visibilityDetailsAnalytics: Boolean,
                            $visibilityDetailsAnalyticsChange: Boolean,
                            $visibilityDetailsNotes: Boolean,
                            $visibilityDetailsTTL: Boolean,
                            $visibilityDetailsCustomFields: Boolean,
                            $visibilityDetailsMetadata: Boolean,
                            $visibilityDetailsQM: Boolean,
                            $visibilityDetailsAIAssistant: Boolean,
                            $availableAIAssistant: [String],
                            $availableOpenQuestion: Boolean,
                            $availableOpenQuestionLogging: Boolean,
                            $aiAssistantLanguage: String,
                            $visibilityDetailsAIAssistantHistory: Boolean,
                            $visibilityCleanUp: Boolean,
                            $replayReasons: String
                        ){
                            createRuleReplay(input:$auth, rule: {
                                name: $name, 
                                group: $group, 
                                text: $text, 
                                replay: $replay, 
                                visibility: $visibility, 
                                visibilityUser: $visibilityUser, 
                                replayUser: $replayUser, 
                                replayCycle: $replayCycle, 
                                recordingFilter: $recordingFilter,
                                visibilityDetails: $visibilityDetails,
                                visibilityDetailsTranscript: $visibilityDetailsTranscript,
                                visibilityDetailsAnalytics: $visibilityDetailsAnalytics,
                                visibilityDetailsAnalyticsChange: $visibilityDetailsAnalyticsChange,
                                visibilityDetailsNotes: $visibilityDetailsNotes,
                                visibilityDetailsTTL: $visibilityDetailsTTL,
                                visibilityDetailsCustomFields: $visibilityDetailsCustomFields,
                                visibilityDetailsMetadata: $visibilityDetailsMetadata,
                                visibilityDetailsQM: $visibilityDetailsQM,
                                visibilityDetailsAIAssistant: $visibilityDetailsAIAssistant,
                                availableAIAssistant: $availableAIAssistant,
                                availableOpenQuestion: $availableOpenQuestion,
                                availableOpenQuestionLogging: $availableOpenQuestionLogging,
                                aiAssistantLanguage: $aiAssistantLanguage,
                                visibilityDetailsAIAssistantHistory: $visibilityDetailsAIAssistantHistory,
                                visibilityCleanUp: $visibilityCleanUp,
                                replayReasons: $replayReasons
                             })
                                    {
                                          name
                                          text
                                     }
                              }
                            `;
export const mutationCreateRuleAccess = gql`
                         mutation createRuleAccess ($auth:AuthInput, $name:String, $group:String, $text:String,
                            $confListUser: Boolean,
                            $confAddUser: Boolean,
                            $confTicket: Boolean,
                            $confTenants: Boolean,
                            $confUserConfig: Boolean,
                            $confRulesRecording: Boolean,
                            $confRulesReplay: Boolean,
                            $confRulesAccess: Boolean,
                            $confRulesAnalytics: Boolean,
                            $confMapUser: Boolean,
                            $confUserAssignment: String,
                            $confAssignRecording: Boolean,
                            $confAssignReplay: Boolean,
                            $confAssignAccess: Boolean,
                            $confAssignAnalytics: Boolean,
                            $confAuditLogs: Boolean,
                            $confJobs: Boolean,
                            $confCustomFields: Boolean,
                            $confAdministrateCustomFields: Boolean,
                            $confDefineActionOnCustomFields: Boolean,
                            $hasCustomFieldsAccess: Boolean,
                            $customFieldsAccessType:String,
                            $customFieldsEditableTime: Int,
                            $accesibleCustomFields: [String],
                            $cfDisableTagging: Boolean,
                            $userReporting: String,
                            $userKpiTotal: Boolean,
                            $userKpiIncoming: Boolean,
                            $userKpiOutgoing: Boolean,
                            $userKpiKeywords: Boolean,
                            $userKpiWallboard: Boolean,
                            $userAllowSharing: Boolean,
                            $userSafe: String,
                            $isUsedForCaseManagement: Boolean,
                            $ownFolder: ConversationSafeRulesInputType,
                            $userDelete: String,
                            $userPropose: Boolean,
                            $userProposeReasoning: Boolean,
                            $userEmailNotification: Boolean,
                            $userProposeUsers: String,
                            $userSafeUsers: String,
                            $userAssignmentUsers: String,
                            $userLiveView: Boolean,
                            $userDenyExport: Boolean,
                            $userDenyUpload: Boolean,
                            $userBulkExport: Boolean,
                            $userBulkRestoreArchive: Boolean,
                            $userBulkSafe: Boolean,
                            $userBulkSafeAdd: Boolean,
                            $userBulkSafeRemove: Boolean,
                            $userBulkDelete: Boolean,
                            $userBulkTranscript: Boolean,
                            $userBulkExcel: Boolean,
                            $userBulkIpRange: String,
                            $userBulkPasswordLength: String,
                            $complianceResultsAccess: Boolean,
                            $complianceQMResultsAccess: Boolean,
                            $userCompliancePolicy: Boolean,
                            $userCompliancePolicyActivate: Boolean,
                            $userCompliancePolicyEdit: Boolean,
                            $userCompliancePolicyAssign: Boolean,
                            $userComplianceAIQuestions: Boolean,
                            $userComplianceQM: Boolean,
                            $userComplianceAIAssistant: Boolean,
                            $denyReportAlarming: Boolean,
                            $allowConvSharing: Boolean,
                            $archivedConversationAccessType: String,
                            $archivedRequestRetrievalReasoningRequired: Boolean,
                            $approvedUsersReplay: String,
                            $editableTimeCustomFields: Boolean,
                            $allowTTLChangeViaCategorization: Boolean,
                            $suspensionConvDelProcess:Boolean,
                            $accMergeAudioToVideo:Boolean,
                            $allowManualMuting: Boolean,
                            $allowAiQuestionsWithoutCompliance: Boolean,
                            $confProfiles: Boolean
                        ){

                            
                          createRuleAccess(input:$auth, rule: {name: $name, group: $group, text: $text,
                            confListUser: $confListUser,
                            confAddUser: $confAddUser,
                            confTicket: $confTicket,
                            confTenants: $confTenants,
                            confUserConfig: $confUserConfig,
                            confRulesRecording: $confRulesRecording,
                            confRulesReplay: $confRulesReplay,
                            confRulesAccess: $confRulesAccess,
                            confRulesAnalytics: $confRulesAnalytics,
                            confMapUser: $confMapUser,
                            confUserAssignment: $confUserAssignment,
                            confAssignRecording: $confAssignRecording,
                            confAssignReplay: $confAssignReplay,
                            confAssignAccess: $confAssignAccess,
                            confAssignAnalytics: $confAssignAnalytics,
                            confAuditLogs: $confAuditLogs,
                            confJobs: $confJobs,
                            confCustomFields: $confCustomFields,
                            confAdministrateCustomFields: $confAdministrateCustomFields,
                            confDefineActionOnCustomFields: $confDefineActionOnCustomFields,
                            hasCustomFieldsAccess: $hasCustomFieldsAccess,
                            customFieldsAccessType:$customFieldsAccessType,
                            customFieldsEditableTime: $customFieldsEditableTime,
                            accesibleCustomFields: $accesibleCustomFields,
                            cfDisableTagging: $cfDisableTagging,
                            userReporting: $userReporting,
                            userKpiTotal: $userKpiTotal,
                            userKpiIncoming: $userKpiIncoming,
                            userKpiOutgoing: $userKpiOutgoing,
                            userKpiKeywords: $userKpiKeywords,
                            userKpiWallboard: $userKpiWallboard,
                            userAllowSharing: $userAllowSharing,
                            userSafe: $userSafe,
                            isUsedForCaseManagement: $isUsedForCaseManagement,
                            ownFolder: $ownFolder,
                            userDelete: $userDelete,
                            userPropose: $userPropose,
                            userProposeReasoning: $userProposeReasoning,
                            userEmailNotification: $userEmailNotification,
                            userProposeUsers: $userProposeUsers,
                            userSafeUsers: $userSafeUsers,
                            userAssignmentUsers: $userAssignmentUsers,
                            userLiveView: $userLiveView,
                            userDenyExport: $userDenyExport,
                            userDenyUpload: $userDenyUpload
                            userBulkExport: $userBulkExport,
                            userBulkRestoreArchive: $userBulkRestoreArchive,
                            userBulkSafe: $userBulkSafe,
                            userBulkSafeAdd: $userBulkSafeAdd,
                            userBulkSafeRemove: $userBulkSafeRemove,
                            userBulkDelete: $userBulkDelete,
                            userBulkTranscript: $userBulkTranscript,
                            userBulkExcel: $userBulkExcel,
                            userBulkIpRange: $userBulkIpRange,
                            userBulkPasswordLength: $userBulkPasswordLength,
                            complianceResultsAccess: $complianceResultsAccess,
                            complianceQMResultsAccess: $complianceQMResultsAccess,
                            userCompliancePolicy: $userCompliancePolicy,
                            userCompliancePolicyActivate: $userCompliancePolicyActivate,
                            userCompliancePolicyEdit: $userCompliancePolicyEdit,
                            userCompliancePolicyAssign: $userCompliancePolicyAssign,
                            userComplianceAIQuestions: $userComplianceAIQuestions,
                            userComplianceQM: $userComplianceQM,
                            userComplianceAIAssistant: $userComplianceAIAssistant
                            denyReportAlarming: $denyReportAlarming,
                            allowConvSharing: $allowConvSharing,
                            archivedConversationAccessType: $archivedConversationAccessType,
                            archivedRequestRetrievalReasoningRequired: $archivedRequestRetrievalReasoningRequired,
                            approvedUsersReplay: $approvedUsersReplay,
                            editableTimeCustomFields: $editableTimeCustomFields,
                            allowTTLChangeViaCategorization: $allowTTLChangeViaCategorization,
                            suspensionConvDelProcess:$suspensionConvDelProcess,
                            accMergeAudioToVideo:$accMergeAudioToVideo,
                            allowManualMuting: $allowManualMuting,
                            allowAiQuestionsWithoutCompliance: $allowAiQuestionsWithoutCompliance,
                            confProfiles: $confProfiles
                          })
                                    {
                                          name
                                          text
                                     }
                              }
                            `;
export const mutationCreateRuleAnalytics = gql`
                         mutation ent ($auth:AuthInput, $name:String, $group:String, $text:String, 
                            $accessType: String,
                            $startTime: DateTime,
                            $endTime: DateTime,
                            $withTranscription: Boolean,
                            $transcriptLanguage: String,
                            $withSentiment: Boolean,
                            $keywordCategories: String,
                            $entityCategories: String,                            
                            $keyphraseExtraction: Boolean,
                            $translationType: String,
                            $userVisible: String,
                            $onDemandSpeech2Text: Boolean,
                            $onDemandKeywords: Boolean,
                            $onDemandEntities: Boolean,
                            $individualKeywords: Boolean,
                            $translationLanguage: String,
                            $screenAnalysis:Boolean,
                            $keywordList: String,
                            $optionAlternativeLanguageKey: String,
                            $multilingualConversations: Boolean,
                            $analyzeAllConditions:[String],
                            $hasSpeakerRecognition:Boolean,
                            $denyDefaultChange:Boolean,
                            $defaultNotTranscribe:Boolean,
                            $policies: String,
                            $transcriptType:String,
                            $transcriptModelWhisper: Boolean,
                            $aiSummaryQuestion: String
                        ){
                            createRuleAnalytics(input:$auth, rule: {name: $name, group: $group, text: $text, 
                            accessType: $accessType,
                            startTime: $startTime,
                            endTime: $endTime,
                            withTranscription: $withTranscription,
                            transcriptLanguage: $transcriptLanguage,
                            withSentiment: $withSentiment,
                            keywordCategories: $keywordCategories,
                            entityCategories: $entityCategories,                            
                            keyphraseExtraction: $keyphraseExtraction,
                            translationType: $translationType,
                            userVisible: $userVisible,
                            onDemandSpeech2Text: $onDemandSpeech2Text,
                            onDemandKeywords: $onDemandKeywords,
                            onDemandEntities: $onDemandEntities,
                            individualKeywords: $individualKeywords,
                            translationLanguage: $translationLanguage,
                            screenAnalysis:$screenAnalysis,
                            keywordList: $keywordList
                            optionAlternativeLanguageKey: $optionAlternativeLanguageKey,
                            multilingualConversations: $multilingualConversations,
                            analyzeAllConditions:$analyzeAllConditions,
                            hasSpeakerRecognition:$hasSpeakerRecognition,
                            denyDefaultChange:$denyDefaultChange,
                            defaultNotTranscribe:$defaultNotTranscribe,
                            policies:$policies,
                            transcriptType:$transcriptType,
                            transcriptModelWhisper:$transcriptModelWhisper,
                            aiSummaryQuestion:$aiSummaryQuestion
                        })
                                    {
                                          name
                                          text
                                     }
                              }
                            `;

export const mutationUpdateRuleRecording = gql`
                         mutation ent ($id :String, $auth:AuthInput, $name:String, $group:String, $time:String, $text:String, $audio:Boolean, $video: Boolean, $screenOnly: Boolean, $chat: Boolean, $mail: Boolean, $audioType: String, $chatType: String, $chatTypeDeny: Boolean, $channelType: String, $areaCode: String, $inboundType: String, $outboundType: String, $meetingType: String, $meetingExternalType: String, $meetingInternalType: String, $internalType: String, $silentRecording: Boolean, $allowList: String, $denyList: String, $meetingOrganizer: String, $meetingParticipant: String, $useOnBehalfOfUserSetting:Boolean, $switchInitialState: Boolean, $disableNextRecording: Boolean, $userStreamOnly: Boolean, $pstnAnnouncement: Boolean, $ascBeeptone:Boolean, $ascBeeptoneFrequency:Int, $announcementType: String, $announcements: String, $deletedFilesFromAnnouncements:[String], $start:String, $stop:String, $isDtmfEnabled: Boolean, $isDtmfAnnouncementSuppressionEnabled:Boolean, $announcementSuppressionCode:String, $announcementSuppressionTimeInDays:Int, $recReevaluateChangeFromOneToOneToMeeting:Boolean, $channelList: String, $demandStartOnly: Boolean, $roDStopReasons:String, $roDStopReasonRequired:Boolean,$keepDeleteSettings:[RecordingKeepDeleteSettingInputType],$recordingTransferorAllowList:String, $recordingTransferorDenyList:String, $meetingSubjectAllowList:String, $meetingSubjectDenyList:String, $disableNextRecordingReasonRequired:Boolean, $disableNextRecordingReasons:String,$trackOnDemandDecision:Boolean, $isEntryVoiceOnly:Boolean, $callQueueRuleOverride:Boolean, $recordSeparateSpeakers:Boolean, $ruleDecisionTracking:Boolean){
                            updateRuleRecording(input:$auth, rule: {id: $id, name: $name, group: $group, text: $text, time: $time, audio: $audio, video: $video, screenOnly: $screenOnly, chat: $chat, mail: $mail, audioType: $audioType, chatType: $chatType, chatTypeDeny: $chatTypeDeny, channelType: $channelType, areaCode: $areaCode, inboundType: $inboundType, outboundType: $outboundType, meetingType: $meetingType, meetingExternalType: $meetingExternalType, meetingInternalType: $meetingInternalType, internalType: $internalType, silentRecording: $silentRecording, allowList: $allowList, denyList: $denyList, meetingOrganizer: $meetingOrganizer, meetingParticipant: $meetingParticipant, useOnBehalfOfUserSetting:$useOnBehalfOfUserSetting, switchInitialState: $switchInitialState, disableNextRecording: $disableNextRecording, userStreamOnly:$userStreamOnly, pstnAnnouncement: $pstnAnnouncement, ascBeeptone:$ascBeeptone, ascBeeptoneFrequency:$ascBeeptoneFrequency,announcementType:$announcementType, announcements:$announcements, deletedFilesFromAnnouncements:$deletedFilesFromAnnouncements, start:$start, stop:$stop, isDtmfEnabled:$isDtmfEnabled, isDtmfAnnouncementSuppressionEnabled:$isDtmfAnnouncementSuppressionEnabled, announcementSuppressionCode:$announcementSuppressionCode, announcementSuppressionTimeInDays:$announcementSuppressionTimeInDays, recReevaluateChangeFromOneToOneToMeeting:$recReevaluateChangeFromOneToOneToMeeting, channelList: $channelList, demandStartOnly: $demandStartOnly,roDStopReasons:$roDStopReasons, roDStopReasonRequired:$roDStopReasonRequired,keepDeleteSettings:$keepDeleteSettings,recordingTransferorAllowList:$recordingTransferorAllowList, recordingTransferorDenyList:$recordingTransferorDenyList, meetingSubjectAllowList:$meetingSubjectAllowList, meetingSubjectDenyList:$meetingSubjectDenyList, disableNextRecordingReasonRequired:$disableNextRecordingReasonRequired, disableNextRecordingReasons:$disableNextRecordingReasons, trackOnDemandDecision:$trackOnDemandDecision, isEntryVoiceOnly:$isEntryVoiceOnly, callQueueRuleOverride:$callQueueRuleOverride, recordSeparateSpeakers:$recordSeparateSpeakers, ruleDecisionTracking:$ruleDecisionTracking})
                                    {
                                          name
                                          text
                                     }
                              }
                            `;
export const mutationUpdateRuleReplay = gql`
                         mutation updateRuleReplay ($id :String, $auth:AuthInput, $name:String, $group:String, $visibility:String, $replay:String,  $text:String, $visibilityUser:String, $replayUser:String, $replayCycle:String, $recordingFilter:RecordingFilterInputType,
                            $visibilityDetails: Boolean,
                            $visibilityDetailsTranscript: Boolean,
                            $visibilityDetailsAnalytics: Boolean,
                            $visibilityDetailsAnalyticsChange: Boolean,
                            $visibilityDetailsNotes: Boolean,
                            $visibilityDetailsTTL: Boolean,
                            $visibilityDetailsCustomFields: Boolean,
                            $visibilityDetailsMetadata: Boolean,
                            $visibilityDetailsQM: Boolean,
                            $visibilityDetailsAIAssistant: Boolean,
                            $availableAIAssistant: [String],
                            $availableOpenQuestion: Boolean,
                            $availableOpenQuestionLogging: Boolean,
                            $aiAssistantLanguage: String,
                            $visibilityDetailsAIAssistantHistory: Boolean,
                            $visibilityCleanUp: Boolean,
                            $replayReasons: String
                            ){
                            updateRuleReplay(
                                input:$auth,
                                rule: {
                                    id: $id,
                                    name: $name,
                                    group: $group,
                                    text: $text,
                                    replay: $replay,
                                    visibility: $visibility,
                                    visibilityUser: $visibilityUser,
                                    replayUser: $replayUser,
                                    replayCycle: $replayCycle,
                                    recordingFilter: $recordingFilter,
                                    visibilityDetails: $visibilityDetails,
                                    visibilityDetailsTranscript: $visibilityDetailsTranscript,
                                    visibilityDetailsAnalytics: $visibilityDetailsAnalytics,
                                    visibilityDetailsAnalyticsChange: $visibilityDetailsAnalyticsChange,
                                    visibilityDetailsNotes: $visibilityDetailsNotes,
                                    visibilityDetailsTTL: $visibilityDetailsTTL,
                                    visibilityDetailsCustomFields: $visibilityDetailsCustomFields,
                                    visibilityDetailsMetadata: $visibilityDetailsMetadata,
                                    visibilityDetailsQM: $visibilityDetailsQM,
                                    visibilityDetailsAIAssistant: $visibilityDetailsAIAssistant,
                                    availableAIAssistant: $availableAIAssistant,
                                    availableOpenQuestion: $availableOpenQuestion,
                                    availableOpenQuestionLogging: $availableOpenQuestionLogging,
                                    aiAssistantLanguage: $aiAssistantLanguage,
                                    visibilityDetailsAIAssistantHistory: $visibilityDetailsAIAssistantHistory,
                                    visibilityCleanUp: $visibilityCleanUp,
                                    replayReasons: $replayReasons
                                })
                                    {
                                          name
                                          text
                                     }
                              }
                            `;
export const mutationUpdateRuleAccess = gql`
                         mutation updateRuleAccess ($id : String, $auth:AuthInput, $name:String, $group:String, $text:String,
                            $confListUser: Boolean,
                            $confAddUser: Boolean,
                            $confTicket: Boolean,
                            $confTenants: Boolean,
                            $confUserConfig: Boolean,
                            $confRulesRecording: Boolean,
                            $confRulesReplay: Boolean,
                            $confRulesAccess: Boolean,
                            $confRulesAnalytics: Boolean,
                            $confMapUser: Boolean,
                            $confUserAssignment: String,
                            $confAssignRecording: Boolean,
                            $confAssignReplay: Boolean,
                            $confAssignAccess: Boolean,
                            $confAssignAnalytics: Boolean,
                            $confAuditLogs: Boolean,
                            $confJobs: Boolean,
                            $confCustomFields: Boolean,
                            $confAdministrateCustomFields: Boolean,
                            $confDefineActionOnCustomFields: Boolean,
                            $hasCustomFieldsAccess: Boolean,
                            $customFieldsAccessType:String,
                            $customFieldsEditableTime: Int,
                            $accesibleCustomFields: [String],
                            $cfDisableTagging: Boolean,
                            $userReporting: String,
                            $userKpiTotal: Boolean,
                            $userKpiIncoming: Boolean,
                            $userKpiOutgoing: Boolean,
                            $userKpiKeywords: Boolean,
                            $userKpiWallboard: Boolean,
                            $userAllowSharing: Boolean,
                            $userSafe: String,
                            $isUsedForCaseManagement: Boolean,
                            $ownFolder: ConversationSafeRulesInputType,
                            $userDelete: String,
                            $userPropose: Boolean,
                            $userProposeReasoning: Boolean,
                            $userEmailNotification: Boolean,
                            $userProposeUsers: String,
                            $userSafeUsers: String,
                            $userAssignmentUsers: String,
                            $userLiveView: Boolean,
                            $userDenyExport: Boolean,
                            $userDenyUpload: Boolean,
                            $userBulkExport: Boolean,
                            $userBulkRestoreArchive: Boolean,
                            $userBulkSafe: Boolean,
                            $userBulkSafeAdd: Boolean,
                            $userBulkSafeRemove: Boolean,
                            $userBulkCase: Boolean,
                            $userBulkCaseAdd: Boolean,
                            $userBulkCaseRemove: Boolean,
                            $userBulkDelete: Boolean,
                            $userBulkTranscript: Boolean,
                            $userBulkExcel: Boolean,
                            $userBulkIpRange: String,
                            $userBulkPasswordLength: String,
                            $complianceResultsAccess: Boolean,
                            $complianceQMResultsAccess: Boolean,
                            $userCompliancePolicy: Boolean,
                            $userCompliancePolicyActivate: Boolean,
                            $userCompliancePolicyInitiateWorkflow: Boolean,
                            $userCompliancePolicyEdit: Boolean,
                            $userCompliancePolicyAssign: Boolean,
                            $userComplianceAIQuestions: Boolean,
                            $userComplianceAIAssistant: Boolean,
                            $userComplianceQM: Boolean,
                            $denyReportAlarming: Boolean,
                            $allowConvSharing: Boolean,
                            $archivedConversationAccessType: String,
                            $archivedRequestRetrievalReasoningRequired: Boolean,
                            $approvedUsersReplay: String,
                            $editableTimeCustomFields: Boolean,
                            $allowTTLChangeViaCategorization: Boolean,
                            $suspensionConvDelProcess:Boolean,
                            $accMergeAudioToVideo:Boolean,
                            $shareOptionWasDisabled: Boolean,
                            $allowManualMuting: Boolean,
                            $allowAiQuestionsWithoutCompliance: Boolean,
                            $confProfiles: Boolean
                        ){

                            
                          updateRuleAccess(input:$auth, rule: {id: $id, name: $name, group: $group, text: $text,
                            confListUser: $confListUser,
                            confAddUser: $confAddUser,
                            confTicket: $confTicket,
                            confTenants: $confTenants,
                            confUserConfig: $confUserConfig,
                            confRulesRecording: $confRulesRecording,
                            confRulesReplay: $confRulesReplay,
                            confRulesAccess: $confRulesAccess,
                            confRulesAnalytics: $confRulesAnalytics,
                            confMapUser: $confMapUser,
                            confUserAssignment: $confUserAssignment,
                            confAssignRecording: $confAssignRecording,
                            confAssignReplay: $confAssignReplay,
                            confAssignAccess: $confAssignAccess,
                            confAssignAnalytics: $confAssignAnalytics,
                            confAuditLogs: $confAuditLogs,
                            confJobs: $confJobs,
                            confCustomFields: $confCustomFields,
                            confAdministrateCustomFields: $confAdministrateCustomFields,
                            confDefineActionOnCustomFields: $confDefineActionOnCustomFields,
                            hasCustomFieldsAccess: $hasCustomFieldsAccess,
                            customFieldsAccessType:$customFieldsAccessType,
                            customFieldsEditableTime: $customFieldsEditableTime,
                            accesibleCustomFields: $accesibleCustomFields,
                            cfDisableTagging: $cfDisableTagging,
                            userReporting: $userReporting,
                            userKpiTotal: $userKpiTotal,
                            userKpiIncoming: $userKpiIncoming,
                            userKpiOutgoing: $userKpiOutgoing,
                            userKpiKeywords: $userKpiKeywords,
                            userKpiWallboard: $userKpiWallboard,
                            userAllowSharing: $userAllowSharing,
                            userSafe: $userSafe,
                            isUsedForCaseManagement: $isUsedForCaseManagement,
                            ownFolder: $ownFolder,
                            userDelete: $userDelete,
                            userPropose: $userPropose,
                            userProposeReasoning: $userProposeReasoning,
                            userEmailNotification: $userEmailNotification,
                            userProposeUsers: $userProposeUsers,
                            userSafeUsers: $userSafeUsers,
                            userAssignmentUsers: $userAssignmentUsers,
                            userLiveView: $userLiveView,
                            userDenyExport: $userDenyExport,
                            userDenyUpload: $userDenyUpload,
                            userBulkExport: $userBulkExport,
                            userBulkRestoreArchive: $userBulkRestoreArchive,
                            userBulkSafe: $userBulkSafe,
                            userBulkSafeAdd: $userBulkSafeAdd,
                            userBulkSafeRemove: $userBulkSafeRemove,
                            userBulkCase: $userBulkCase,
                            userBulkCaseAdd: $userBulkCaseAdd,
                            userBulkCaseRemove: $userBulkCaseRemove,
                            userBulkDelete: $userBulkDelete,
                            userBulkTranscript: $userBulkTranscript,
                            userBulkExcel: $userBulkExcel,
                            userBulkIpRange: $userBulkIpRange,
                            userBulkPasswordLength: $userBulkPasswordLength,
                            complianceResultsAccess: $complianceResultsAccess,
                            complianceQMResultsAccess: $complianceQMResultsAccess,
                            userCompliancePolicy: $userCompliancePolicy,
                            userCompliancePolicyActivate: $userCompliancePolicyActivate,
                            userCompliancePolicyInitiateWorkflow: $userCompliancePolicyInitiateWorkflow,  
                            userCompliancePolicyEdit: $userCompliancePolicyEdit,
                            userCompliancePolicyAssign: $userCompliancePolicyAssign,
                            userComplianceAIQuestions: $userComplianceAIQuestions,
                            userComplianceQM: $userComplianceQM,
                            userComplianceAIAssistant: $userComplianceAIAssistant
                            denyReportAlarming: $denyReportAlarming,
                            allowConvSharing: $allowConvSharing,
                            archivedConversationAccessType: $archivedConversationAccessType,
                            archivedRequestRetrievalReasoningRequired: $archivedRequestRetrievalReasoningRequired,
                            approvedUsersReplay: $approvedUsersReplay,
                            editableTimeCustomFields: $editableTimeCustomFields,
                            allowTTLChangeViaCategorization: $allowTTLChangeViaCategorization,
                            suspensionConvDelProcess:$suspensionConvDelProcess,
                            allowManualMuting: $allowManualMuting,
                            allowAiQuestionsWithoutCompliance: $allowAiQuestionsWithoutCompliance,
                            confProfiles: $confProfiles,
                            accMergeAudioToVideo:$accMergeAudioToVideo
                          },
                              shareOptionWasDisabled : $shareOptionWasDisabled
                          )
                                    {
                                          name
                                          text
                                     }
                              }
                            `;
export const mutationUpdateRuleAnalytics = gql`
                         mutation ent ($id :String, $auth:AuthInput, $name:String, $group:String, $text:String, 
                            $accessType: String,
                            $startTime: DateTime,
                            $endTime: DateTime,
                            $withTranscription: Boolean,
                            $transcriptLanguage: String,
                            $withSentiment: Boolean,
                            $keywordCategories: String,
                            $entityCategories: String,                            
                            $keyphraseExtraction: Boolean,
                            $translationType: String,
                            $userVisible: String,
                            $onDemandSpeech2Text: Boolean,
                            $onDemandKeywords: Boolean,
                            $onDemandEntities: Boolean,
                            $individualKeywords: Boolean,
                            $translationLanguage: String,
                            $screenAnalysis:Boolean,
                            $keywordList: String,
                            $optionAlternativeLanguageKey: String,
                            $multilingualConversations: Boolean,
                            $analyzeAllConditions:[String],
                            $hasSpeakerRecognition:Boolean,
                            $denyDefaultChange:Boolean,
                            $defaultNotTranscribe:Boolean,
                            $policies: String,
                            $transcriptType:String,
                            $transcriptModelWhisper:Boolean,
                            $aiSummaryQuestion: String

                        ){
                            updateRuleAnalytics(input:$auth, rule: {id: $id, name: $name, group: $group, text: $text, 
                            accessType: $accessType,
                            startTime: $startTime,
                            endTime: $endTime,
                            withTranscription: $withTranscription,
                            transcriptLanguage: $transcriptLanguage,
                            withSentiment: $withSentiment,
                            keywordCategories: $keywordCategories,
                            entityCategories: $entityCategories,                            
                            keyphraseExtraction: $keyphraseExtraction,
                            translationType: $translationType,
                            userVisible: $userVisible,
                            onDemandSpeech2Text: $onDemandSpeech2Text,
                            onDemandKeywords: $onDemandKeywords,
                            onDemandEntities: $onDemandEntities,
                            individualKeywords: $individualKeywords,
                            translationLanguage: $translationLanguage,
                            screenAnalysis:$screenAnalysis,
                            keywordList: $keywordList,
                            optionAlternativeLanguageKey: $optionAlternativeLanguageKey,
                            multilingualConversations: $multilingualConversations,
                            analyzeAllConditions:$analyzeAllConditions,
                            hasSpeakerRecognition:$hasSpeakerRecognition,
                            denyDefaultChange:$denyDefaultChange,
                            defaultNotTranscribe:$defaultNotTranscribe,
                            policies:$policies,
                            transcriptType:$transcriptType,
                            transcriptModelWhisper:$transcriptModelWhisper,
                            aiSummaryQuestion:$aiSummaryQuestion
                        })
                                    {
                                          name
                                          text
                                     }
                              }
                            `;

export const queryGetAWSRegions = gql`
    query ent ($auth:AuthInput){
        getAWSRegions(input:$auth)
        {
            displayName
            code
        }
    }
`;

export const getCognitiveServicesLocalesTranscription = gql`
    query ent ($auth:AuthInput){
        getTranscriptionLocales(input:$auth)
            
        }
        `;

export const getCognitiveServicesLocalesTranslation = gql`
    query ent ($auth:AuthInput){
        getTranslatorLocales(input:$auth)
            
        }
        `;




export const mutationUpdateCustomField = gql`
                         mutation ent ($auth:AuthInput, $customField:CustomFieldsInput){
                            updateCustomField(input:$auth, customField: $customField)
                                    {
                                          fieldName
                                          id
                                    }
                              }
                            `;

export const mutationCreateCustomField = gql`
                         mutation ent ($auth:AuthInput, $customField:CustomFieldsInput){
                            createCustomField(input:$auth, customField: $customField)
                                    {
                                          fieldName
                                    }
                              }
                            `;

export const getAllCustomFields = gql`
                          query ent ($auth:AuthInput){
                            getAllCustomFieldDefinitions(input:$auth)
                                    {
                                              tenantId
                                              fieldName
                                              isNumeric
                                              isAlphanumeric
                                              maxNumberOfFields
                                              fieldLength
                                              hasExactLength
                                              isCheckbox
                                              id
                                              hasTriggerAction
                                              hasAdditionalNumberCheck
                                              actionType
                                              ttlSettingYes
                                              ttlSettingNo
                                              notifications
                                              mapping
                                    }
                              }
                            `;

export const getStorageData = gql`
                          query ent ($auth:AuthInput){
                            getStorageData(input:$auth)
                                    {
                                              displayName
                                              id
                                              storageLocation
                                    }
                              }
                            `;


export const getAllNameCustomFields = gql`
                          query ent ($auth:AuthInput){
                            getAllCustomFieldDefinitions(input:$auth) {
                                    id
                                    fieldName
                            }
                          }
                      `;

export const updateCallCustomField = gql`
                mutation ent ($auth:AuthInput, $conversationId : String!, $customFields: String) {
                    updateCallCustomField (input:$auth, conversationId: $conversationId, customFields: $customFields)
                }
                `

export const getAllCustomFieldDefinitions = gql`
                          query ent ($auth:AuthInput){
                            getAllCustomFieldDefinitions(input:$auth) {
                                 id
                                 fieldName
                            }
                          }
                      `;


export const mutationCheckCustomFieldIsUsed = gql`
                         mutation ent ($auth:AuthInput, $customFieldId:String){
                            checkCustomFieldIsUsed(input:$auth, customFieldId:$customFieldId)
                                   
                              }
                            `;
export const mutationDeleteCustomField = gql`
                         mutation ent ($auth:AuthInput, $customFieldId:String){
                            deleteCustomField(input:$auth,customFieldId: $customFieldId)
                                
                              }
                            `;

export const mutationSaveListViewSettings = gql`
                         mutation ent ($listViewSettings:[String]){
                            saveListViewSettings(listViewSettings: $listViewSettings){
                                            text
                                            status
                                            id
                                }

                              }
                            `;

export const mutationSaveListTenantSettings = gql`
                         mutation ent ($listTenantSettings:[String]){
                            saveListTenantSettings(listTenantSettings: $listTenantSettings){
                                            text
                                            status
                                            id
                                }

                              }
                            `;

export const mutationSaveListTicketSettings = gql`
                         mutation ent ($listTicketSettings:[String]){
                            saveListTicketSettings(listTicketSettings: $listTicketSettings){
                                            text
                                            status
                                            id
                                }

                              }
                            `;

export const mutationSaveListStorageSettings = gql`
                         mutation ent ($listStorageSettings:[String]){
                            saveListStorageSettings(listStorageSettings: $listStorageSettings){
                                            text
                                            status
                                            id
                                }

                              }
                            `;


export const queryGetLoggedUserData = gql`
                          query ent ($auth:AuthInput){
                            getLoggedUserData(input:$auth)
                                    {
                                       userId
                                       listViewSettings
                                       listTenantSettings
                                       listStorageSettings
                                       listTicketSettings
                                    }
                              }
                            `;

export const mutationMarkDeleteExportRule = gql`
                         mutation ent ($auth:AuthInput, $rule:ExportRuleInputType){
                            markDeleteExportRule(input:$auth, rule:$rule)
                              }
                            `;
export const mutationMarkDeleteImportRule = gql`
                         mutation ent ($auth:AuthInput,$rule:ImportRuleInputType){
                            markDeleteImportRule(input:$auth,rule:$rule)
                              }
                            `;
export const checkRetentionTimeValidity = gql`
                         mutation ent ($auth:AuthInput, $ttl: Int){
                            checkRetentionTimeValidity(input:$auth, ttl: $ttl)
                                   
                              }
                            `;
export const checkS3StorageConnection = gql`
                         mutation ent ($auth:AuthInput, $id:String, $secret:String, $region:String, $bucket:String, $awsServiceUrl:String, $awsType:String){
                            checkS3StorageConnection(input:$auth, id:$id, secret:$secret, region:$region, bucket:$bucket, awsServiceUrl:$awsServiceUrl, awsType:$awsType)
                                   
                              }
                            `;

export const createAsymmetricKey = gql`
                         mutation ent ($auth:AuthInput, $tenantid:String, $vaultUrl: String, $keyName: String, $keySize: Int, $hsm: Boolean){
                            createAsymmetricKey(input:$auth, tenantid:$tenantid, vaultUrl:$vaultUrl, keyName:$keyName, keySize:$keySize , hsm:$hsm)
                                   
                              }
                            `;

export const checkCustomFieldName = gql`
                         mutation ent ($auth:AuthInput, $fieldName:String){
                            checkCustomFieldName(input:$auth, fieldName:$fieldName)
                                   
                              }
                           
                            `;

export const mutationUpdateStorage = gql`
                         mutation ent ($auth:AuthInput, $storage:StorageInputType){
                            updateStorage(input:$auth, storage: $storage)
                                    {
                                          displayName
                                          id
                                    }
                              }
                            `;

export const mutationCreateStorageAccount = gql`
                         mutation ent ($auth:AuthInput, $storage:StorageInputType){
                            createStorage(input:$auth, storage: $storage)
                                    {
                                          displayName
                                    }
                              }
                            `;
export const getProcessingRegions = gql`
    query ent ($auth:AuthInput){
        getProcessingRegions(input:$auth)
            
        }
        `;
export const getTenantRegions = gql`
    query ent ($auth:AuthInput){
        getTenantRegions(input:$auth)
            
        }
        `;

export const mutationCheckStorageIsUsed = gql`
                         mutation ent ($auth:AuthInput, $storageId:String){
                            checkStorageIsUsed(input:$auth, storageId:$storageId)
                                   
                              }
                            `;

export const mutationDeleteStorage = gql`
                         mutation ent ($auth:AuthInput, $storageId:String){
                            deleteStorage(input:$auth,storageId: $storageId)
                                
                              }
        `;

export const mutationCreateUserProfile = gql`
    mutation ent($input: AuthInput, $profile: ProfileInputType) {
        createUserProfile(input: $input, profile: $profile) {
            id
           
        }
    }
`;

export const mutationUpdateUserProfile = gql`
    mutation ent($input: AuthInput, $profile: ProfileInputType) {
        updateUserProfile(input: $input, profile: $profile) {
            id
         
        }
    }
`;

export const mutationDeleteUserProfile = gql`
    mutation ent($id: String!) {
        deleteUserProfile(id: $id) {
            id
        }
    }
`;

export const mutationCreateUserProfileRule = gql`
    mutation ent($input: AuthInput, $profileRule: UserProfileRuleInputType) {
        createUserProfileRule(input: $input, profileRule: $profileRule) {
            id
            name
            text
        }
    }
`;
export const mutationUpdateUserProfileRule = gql`
    mutation ent($input: AuthInput, $profileRule: UserProfileRuleInputType) {
        updateUserProfileRule(input: $input, profileRule: $profileRule) {
            id
            name
            text
        }
    }
`;
export const mutationDeleteUserProfileRule = gql`
    mutation ent($id: String!) {
        deleteUserProfileRule(id: $id) {
            id
        }
    }
`;

export const queryGetTimezonesList = gql`
                          query ent ($auth:AuthInput){
                            getTimezonesList(input:$auth){
                                   id
                                   displayName
                            }
                          }
                      `;
export const getProfileRule = gql`
    query ent ($auth:AuthInput, $id: ID!){
        getProfileRule(input:$auth, id: $id){
            id
            tenantId
            name
            text
            announcementType
            announcementSetting
            enableBeepTone
            beepToneDelay
            isEntryVoiceOnly
            callQueueRuleOverride
            announcements {
                prefixList
                start
                stop
            }
            filters {
                lists {
                    type
                    entries
                    matchMode
                    isActive
                }
                statistics {
                    useStatistics
                    statisticsRecordingType
                    amountOfConversationsToRecord
                    recordingInterval
                    useSchedulingFilter
                }
                conversationType
                schedulingFilter {
                    hasDurationFilter
                    duration {
                        min
                        max
                    }
                    timetable {
                        daily {
                            start
                            stop
                        }
                        weekly {
                            days
                            start
                            stop
                        }
                        monthly {
                            quantifier
                            days
                            start
                            stop
                        }
                    }
                }
                recordingType {
                    recAudioType
                    bulk {
                        hasStartStops
                        startStops
                        stopReasonRequired
                        stopReasons
                        recordingStartsAfter
                        recordingDelayEnabled
                    }
                    rod {
                        hasStartStops
                        stopReasonRequired
                        stopReasons
                        startStops
                    }
                    recordingControl {
                        hasStartStops
                        recordingStartsAfter
                        startStops
                        autoStartRecording
                        stopReasonRequired
                        stopReasons
                    }
                    media {
                        ttl
                        ttlType
                        metadata {
                            isActive
                            ttl
                            isRod
                        }
                        audio {
                            isActive
                            ttl
                            isRod
                        }
                        video {
                            isActive
                            ttl
                            isRod
                        }
                        screen {
                            isActive
                            ttl
                            isRod
                        }
                    }
                    startMode
                    hasKeepDelete
                    wrapUp
                    hasWrapUp
                }
            }
        }
    }
`;



export const checkExportConnectionString = gql`
  mutation ent($auth: AuthInput, $exportRuleType: String, $storageConnectionString: String, $storageContainerName: String, $awsExportRegion: String, $neoTransferId: String, $conversationClientId: String,$conversationClientSecret:String, $voiceClientId:String, $voiceClientSecret: String,$sftpPrivateKeyUpload:String,$sftpPrivateKeyGenerated:String ) {
    checkExportConnectionString(input: $auth, exportRuleType: $exportRuleType, storageConnectionString: $storageConnectionString, storageContainerName: $storageContainerName, awsExportRegion: $awsExportRegion, neoTransferId: $neoTransferId, conversationClientId: $conversationClientId, conversationClientSecret:$conversationClientSecret, voiceClientId:$voiceClientId, voiceClientSecret:$voiceClientSecret, sftpPrivateKeyUpload:$sftpPrivateKeyUpload, sftpPrivateKeyGenerated:$sftpPrivateKeyGenerated)
  }
`;

export const checkImportConnectionString = gql`
  mutation ent($auth: AuthInput, $importRuleType: String, $storageConnectionString: String, $storageContainerName: String, $neoTransferId: String) {
    checkImportConnectionString(input: $auth, importRuleType: $importRuleType, storageConnectionString: $storageConnectionString, storageContainerName: $storageContainerName, neoTransferId: $neoTransferId)
  }
`;

export const mutationCreatePublicKey = gql`
    mutation createPublicKey($input: AuthInput, $password: String) {
        createPublicKey(input: $input, password: $password)
        {
            sftpPublicKey
            sftpPrivateKey
        }
    }
`;

export const mutationLogout = gql`mutation logout($auth: AuthInput) { logout(input: $auth) }`;
